export const MAX_SEARCH_WORDS = 10;
export const MAX_SEARCH_CHARACTERS = 200;
